(() => {
  const toInt = (v) => {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isFinite(n) ? n : null;
  };

  // Passo (step) da linha = tamanho do combo com que o item foi adicionado.
  // Vem de data-bq-step (renderizado no Liquid a partir de _bundle_qty).
  // Fallback p/ itens antigos sem a propriedade: usa o MENOR tier (q1/q2/q3), se existir.
  const getStep = (quantityInputEl) => {
    const step = toInt(quantityInputEl.dataset.bqStep);
    if (step && step > 0) return step;

    const tiers = [
      toInt(quantityInputEl.dataset.bqQ1),
      toInt(quantityInputEl.dataset.bqQ2),
      toInt(quantityInputEl.dataset.bqQ3),
    ].filter((n) => n && n > 0);

    if (!tiers.length) return null;
    return Math.min(...tiers);
  };

  // + : sobe um combo (multiplo do passo)
  const nextQty = (current, step) => {
    const cur = Math.max(0, toInt(current) ?? 0);
    if (cur <= 0) return step;
    if (cur % step === 0) return cur + step;               // ex.: 6 -> 12, 10 -> 20, 20 -> 40
    return (Math.floor(cur / step) + 1) * step;             // valor "torto" -> proximo multiplo
  };

  // - : desce um combo; abaixo de 1 combo => remove a linha (retorna 0)
  const prevQty = (current, step) => {
    const cur = Math.max(0, toInt(current) ?? 0);
    if (cur <= step) return 0;                              // ex.: 6 -> remove
    if (cur % step === 0) return cur - step;                // ex.: 12 -> 6, 20 -> 10
    return Math.floor(cur / step) * step;                   // valor "torto" -> multiplo de baixo
  };

  const clickNativeRemove = (qi, input) => {
    const row =
      qi.closest("tr.cart-item") ||
      qi.closest("tr") ||
      qi.closest(".cart-item") ||
      qi.closest("[id^='CartItem-']") ||
      qi.closest("[id^='CartDrawer-Item-']");

    const candidate =
      row?.querySelector("cart-remove-button button") ||
      row?.querySelector("cart-remove-button a") ||
      document.querySelector(`cart-drawer cart-remove-button[data-index="${input?.dataset?.index}"] button`) ||
      document.querySelector(`cart-items cart-remove-button[data-index="${input?.dataset?.index}"] a`);

    if (!candidate) return false;
    candidate.click();
    return true;
  };

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("quantity-input .quantity__button");
      if (!btn) return;

      const qi = btn.closest("quantity-input");
      if (!qi) return;

      // Funciona no cart-drawer OU na pagina /cart
      const inDrawer = !!qi.closest("cart-drawer");
      const inCartPage = !!qi.closest("cart-items") || !!qi.closest("#main-cart-items");
      if (!inDrawer && !inCartPage) return;

      const step = getStep(qi);
      if (!step) return; // sem combo => comportamento padrao do tema

      const input = qi.querySelector("input.quantity__input");
      if (!input) return;

      const name = btn.getAttribute("name");
      const isPlus = name === "plus";
      const isMinus = name === "minus";
      if (!isPlus && !isMinus) return;

      // bloqueia o handler padrao do tema
      e.preventDefault();
      e.stopImmediatePropagation();

      const current = toInt(input.value) ?? 0;
      const desired = isPlus ? nextQty(current, step) : prevQty(current, step);
      if (desired === current) return;

      if (desired === 0) {
        if (clickNativeRemove(qi, input)) return;

        // fallback (raro)
        input.value = "0";
        input.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      input.value = String(desired);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    },
    true
  );
})();